/**
 * Bank options constant for shop bank account selection
 */
export const BANK_OPTIONS = [
  { value: '-', label: '-' },
  { value: 'ธนาคารกรุงเทพ จำกัด (มหาชน)', label: 'ธนาคารกรุงเทพ จำกัด (มหาชน)' },
  { value: 'ธนาคารกรุงไทย จำกัด (มหาชน)', label: 'ธนาคารกรุงไทย จำกัด (มหาชน)' },
  { value: 'ธนาคารกรุงศรีอยุธยา จำกัด (มหาชน)', label: 'ธนาคารกรุงศรีอยุธยา จำกัด (มหาชน)' },
  { value: 'ธนาคารกสิกรไทย จำกัด (มหาชน)', label: 'ธนาคารกสิกรไทย จำกัด (มหาชน)' },
  { value: 'ธนาคารเกียรตินาคินภัทร จำกัด (มหาชน)', label: 'ธนาคารเกียรตินาคินภัทร จำกัด (มหาชน)' },
  { value: 'ธนาคารซิตี้แบงก์ เอ็น. เอ.', label: 'ธนาคารซิตี้แบงก์ เอ็น. เอ.' },
  { value: 'ธนาคารซีไอเอ็มบี ไทย จำกัด (มหาชน)', label: 'ธนาคารซีไอเอ็มบี ไทย จำกัด (มหาชน)' },
  { value: 'ธนาคารทหารไทยธนชาต จำกัด (มหาชน)', label: 'ธนาคารทหารไทยธนชาต จำกัด (มหาชน)' },
  { value: 'ธนาคารทิสโก้ จำกัด (มหาชน)', label: 'ธนาคารทิสโก้ จำกัด (มหาชน)' },
  { value: 'ธนาคารไทยพาณิชย์ จำกัด (มหาชน)', label: 'ธนาคารไทยพาณิชย์ จำกัด (มหาชน)' },
  { value: 'ธนาคารไทยเครดิต จำกัด (มหาชน)', label: 'ธนาคารไทยเครดิต จำกัด (มหาชน)' },
  { value: 'ธนาคารยูโอบี จำกัด (มหาชน)', label: 'ธนาคารยูโอบี จำกัด (มหาชน)' },
  {
    value: 'ธนาคารสแตนดาร์ดชาร์เตอร์ด (ไทย) จำกัด (มหาชน)',
    label: 'ธนาคารสแตนดาร์ดชาร์เตอร์ด (ไทย) จำกัด (มหาชน)',
  },
  {
    value: 'ธนาคารแลนด์แอนด์เฮ้าส์ จำกัด (มหาชน)',
    label: 'ธนาคารแลนด์แอนด์เฮ้าส์ จำกัด (มหาชน)',
  },
  {
    value: 'ธนาคารแห่งอุตสาหกรรมและการค้าจีน (ไทย) จำกัด (มหาชน)',
    label: 'ธนาคารแห่งอุตสาหกรรมและการค้าจีน (ไทย) จำกัด (มหาชน)',
  },
  { value: 'ธนาคารออมสิน', label: 'ธนาคารออมสิน' },
  {
    value: 'ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร (ธ.ก.ส.)',
    label: 'ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร (ธ.ก.ส.)',
  },
  { value: 'ธนาคารอาคารสงเคราะห์ (ธอส.)', label: 'ธนาคารอาคารสงเคราะห์ (ธอส.)' },
  { value: 'ธนาคารอิสลามแห่งประเทศไทย', label: 'ธนาคารอิสลามแห่งประเทศไทย' },
  {
    value: 'ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดยอดกลางแห่งประเทศไทย (SME D Bank)',
    label: 'ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดยอดกลางแห่งประเทศไทย (SME D Bank)',
  },
  {
    value: 'ธนาคารเพื่อการส่งออกและนำเข้าแห่งประเทศไทย (EXIM Bank)',
    label: 'ธนาคารเพื่อการส่งออกและนำเข้าแห่งประเทศไทย (EXIM Bank)',
  },
];

/**
 * Account status options for shop status selection
 */
export const STATUS_OPTIONS = [
  { value: 'approved', label: 'อนุมัติแล้ว' },
  { value: 'pending', label: 'รอดำเนินการ' },
  { value: 'suspended', label: 'ระงับ' },
];

/**
 * Document status options for shop document status selection
 */
export const DOCUMENT_STATUS_OPTIONS = [
  { value: 'submited', label: 'ส่งแล้ว' },
  { value: 'pending', label: 'รอดำเนินการ' },
];
